import { c as _c } from "react/compiler-runtime";
import styled from 'styled-components';
import { LabelText, UppercaseLabelText } from './LabelText';
import { Flex4XS } from '@/components/Flex';
import Icon from '../Icon/Icon';
import React from 'react';
const Box = styled(Flex4XS)<{
  $size?: string;
}>`
    display: inline-flex;
    border-radius: ${({
  theme
}) => theme.extras.radius.sm};
    padding-left: ${({
  theme
}) => theme.spacing['3xs']};
    padding-right: ${({
  theme
}) => theme.spacing['3xs']};

    justify-content: space-between;
    align-items: center;
    white-space: nowrap;

    // padding-top: ${({
  $size
}) => $size === 'xs' ? '4px' : '1px'};
    // padding-bottom: ${({
  $size
}) => $size === 'xs' ? '4px' : '1px'};
    
    height: ${({
  $size
}) => $size === 'xs' ? '24px' : '18px'};

    color: ${({
  theme
}) => theme.colors.palette.white};
    background-color: ${({
  theme
}) => theme.colors.palette.grey_900};
`;
const StyledIcon = styled(Icon)`
    color: ${({
  theme
}) => theme.colors.palette.white};
`;
export type LabelProps = {
  uppercase?: boolean;
  children?: React.ReactNode;
  leftIcon?: string | React.ReactNode;
  rightIcon?: string | React.ReactNode;
  size?: 'xs' | '2xs';
  noChildrenWrap?: boolean;
};
const Label = t0 => {
  const $ = _c(22);
  let children;
  let leftIcon;
  let rest;
  let rightIcon;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      uppercase: t1,
      children,
      leftIcon,
      rightIcon,
      size: t2,
      noChildrenWrap: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = leftIcon;
    $[3] = rest;
    $[4] = rightIcon;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    children = $[1];
    leftIcon = $[2];
    rest = $[3];
    rightIcon = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  const uppercase = t1 === undefined ? false : t1;
  const size = t2 === undefined ? "2xs" : t2;
  const noChildrenWrap = t3 === undefined ? false : t3;
  const TextComponent = uppercase ? UppercaseLabelText : LabelText;
  let t4;
  if ($[8] !== leftIcon) {
    t4 = leftIcon && (typeof leftIcon === "string" ? <StyledIcon size="sm" name={leftIcon} /> : leftIcon);
    $[8] = leftIcon;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== TextComponent || $[11] !== children || $[12] !== noChildrenWrap) {
    t5 = noChildrenWrap ? children : <TextComponent>{children}</TextComponent>;
    $[10] = TextComponent;
    $[11] = children;
    $[12] = noChildrenWrap;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== rightIcon) {
    t6 = rightIcon && (typeof rightIcon === "string" ? <StyledIcon size="sm" name={rightIcon} /> : rightIcon);
    $[14] = rightIcon;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== rest || $[17] !== size || $[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = <Box $size={size} {...rest}>{t4}{t5}{t6}</Box>;
    $[16] = rest;
    $[17] = size;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};
export default Label;